import axios from "axios";

const ROLE: string = "10";

const getAuthUrl = () =>
  process.env.REACT_APP_PLAYIT_MAINAPI! + "/v2/Authenticate";
const getAuthRefreshUrl = () =>
  process.env.REACT_APP_PLAYIT_MAINAPI! + "/v2/Authenticate/RefreshToken";

interface Jwt {
  token?: string;
  refreshToken?: string;
}
export interface AuthenticationResponse {
  jwt: Jwt;
  organizationIDs: string[];
  role: number;
  userID: string;
}

export class AuthenticationService {
  private static _onLogout: () => void;

  static async Authenticate(
    email: string,
    password: string
  ): Promise<AuthenticationResponse | null> {
    try {
      var { data, status } = await axios.post<AuthenticationResponse>(
        getAuthUrl(),
        { email, password, requestedRole: ROLE }
      );
      if (status === 200) return data;
    } catch (error: any) {
      console.log(error.message);
    }
    return null;
  }

  static async AuthenticateWithRefreshToken(): Promise<AuthenticationResponse | null> {
    var email = localStorage.getItem("email");
    var userID = localStorage.getItem("userID");
    var refreshToken = localStorage.getItem("refreshToken");

    let data: AuthenticationResponse | null = null;

    if (email && userID && refreshToken) {
      var url =
        getAuthRefreshUrl() +
        "?userID=" +
        userID +
        "&RefreshToken=" +
        refreshToken +
        "&RequestedRole=" +
        ROLE;

      await axios
        .get<AuthenticationResponse>(url)
        .then((response) => {
          data = response.data;
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    }
    return data;
  }

  static async SetOnLogout(onLogout: () => void) {
    this._onLogout = onLogout;
  }

  static async Logout() {
    this._onLogout?.();
  }
}
